import { FuseSettingsConfigType } from "@fuse/core/FuseSettings/FuseSettings";
import { PartialDeep } from "type-fest";

export const layoutConfigOnlyMain: PartialDeep<FuseSettingsConfigType>["layout"] = {
	config: {
		navbar: {
			display: false,
		},
		toolbar: {
			display: false,
		},
		footer: {
			display: false,
		},
		leftSidePanel: {
			display: false,
		},
		rightSidePanel: {
			display: false,
		},
	},
};

export const layoutConfigOnlyMainFullWidth: PartialDeep<FuseSettingsConfigType>["layout"] = {
	config: {
		...layoutConfigOnlyMain.config,
		mode: "fullwidth",
	},
};

export const layoutNoContainer: PartialDeep<FuseSettingsConfigType>["layout"] = {
	config: {
		mode: "fullwidth",
	},
};
